import { type SiteDetailResponse, type SiteResponse } from '@on3/api/src';
import { ResizedImage } from '@public/components/Image/ResizedImage';
import { Forums } from '@public/components/Svg/Forums';

import styles from './JoinForum.module.scss';

export const JoinForum = ({
  details,
  site,
}: {
  details: SiteDetailResponse;
  site: SiteResponse;
}) => {
  const { primaryForum } = site;
  const { forumsAssetOne, forumsAssetTwo, forumsDescription } = details;

  const forumName = primaryForum?.title || 'Message Board';

  return (
    <section className={styles.block}>
      <div className={styles.content}>
        <p className={styles.subtitle}>
          <Forums />
          Message Boards
        </p>
        <h2 className={styles.title}>{forumName}</h2>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: forumsDescription || '' }}
        />
      </div>
      <div className={styles.assets}>
        {forumsAssetOne && (
          <ResizedImage
            className={styles.assetOne}
            {...forumsAssetOne}
            fit="cover"
            gravity="0.5x0.5"
            height={285}
            quality={90}
            width={150}
          />
        )}

        {forumsAssetTwo && (
          <ResizedImage
            className={styles.assetTwo}
            {...forumsAssetTwo}
            fit="cover"
            gravity="0.5x0.5"
            height={285}
            quality={90}
            width={400}
          />
        )}
      </div>
    </section>
  );
};
